export default __webpack_public_path__ + "static/media/order.56f03697.mp3";